<template>
<span v-if="refund !== null && order !== null">
    <div class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Retour #{{refund.id}}
          <refund-status-badge :refund="refund"/>
        </h3>
      </div>
      <order-timeline :order="order"></order-timeline>
    </div>
    <order-address :order="order"></order-address>
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Producten</h3>
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th style="width: 150px;">EAN</th>
                <th>Product</th>
                <th>Aantal geleverd</th>
                <th>Aantal geretourneerd</th>
                <th>Voorraad toename</th>
                <th>Korting (in procenten)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="line in orderLines" :key="line.id">
                <td v-if="line.product">
                  <a class="font-w600" href="#">{{line.product.gtin}}</a>
                </td>
                <td>{{line.product.name}}</td>
                <td>{{line.quantity}} X {{ line.product_price}}</td>
                <td>
                  <div v-if="refund.status !== 'completed'" class="row" >
                    <input :id="line.id"  type="number" ref="input" value="0" min="0" :max="line.quantity" class="form-control" style="width: 60px;">
                    <button type="submit" class="btn btn-success btn-noborder"  @click="updateAmountOfProductRefunded(line)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                  <div v-else> {{amountRefundedValue(line.product.id)}} </div>         
                </td>
                <td>
                  <div v-if="refund.status !== 'completed'" class="row">
                    <input :id="line.id" ref="quantityInput" type="number" class="form-control" :max="line.quantity" style="width: 80px;">
                  </div>
                  <div v-else> {{stockIncreaseValue(line.product.id)}} </div>
                </td>
                <td>
                  <div v-if="refund.status !== 'completed' && !isFromMarketPlace" class="row">
                    <input :id="line.id" ref="priceInput" type="number" class="form-control" style="width: 60px;">
                    <button type="submit" class="btn btn-success btn-noborder" @click="updateProductPrice(line)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                  <div v-else> {{discountValue(line.product.id)}}% </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="refund.status !== 'completed' && !isFromMarketPlace">
        <div class="form-group">
          <div>
            <label class="css-control css-control-primary css-checkbox" for="orderStatus">
              <input type="checkbox" class="css-control-input" id="orderStatus" name="orderStatus" value="true" v-model="orderStatus">
              <span class="css-control-indicator"></span> Bestelling status op compleet zetten?
            </label>
          </div>
          <div>
            <label class="css-control css-control-primary css-checkbox" for="refundMail">
              <input type="checkbox" class="css-control-input" id="refundMail" name="refundMail" value="true" v-model="sendRefundConformationMail">
              <span class="css-control-indicator"></span> Retour bevestiging mail sturen?
            </label>
          </div>
          <div>
            <label v-if="includeRefundShipmentCosts" class="css-control css-control-primary css-checkbox" for="calculateRefundShipmentCosts">
              <input type="checkbox" class="css-control-input" id="calculateRefundShipmentCosts" name="calculateRefundShipmentCosts" value="true" v-model="calculateRefundShipmentCosts">
              <span class="css-control-indicator"></span> Retour Kosten: {{ refundShippingCost }},-
            </label>
          </div>

        <div>
          <label v-if="includeRefundShipmentCosts" class="css-control css-control-primary css-checkbox" for="orderShipmentCosts">
            <input type="checkbox" class="css-control-input" id="orderShipmentCosts" name="orderShipmentCosts" value="true" v-model="includeOrderShipmentCosts">
            <span class="css-control-indicator"></span> Verzend Kosten: {{orderShippingCost}}
          </label>

          <p v-if="includeOrderShipmentCosts">
            <span>Verzend kosten </span>
            <exclude-toggle v-model="incrementOrderShimentCosts" />
            <span> totaal bedrag</span>
          </p>
       </div>
      </div>
        <div class="form-group">
            <label for="retourInput">Vul handmatig een (extra) retourbedrag in</label>
            <input type="number" value="0" class="form-control" name="retourInput"  v-model.number="manualRefundPrice" >
        </div>
        <div class="block block-bordered" v-if="refund != null">
          <div class="block-header block-header-default">
            <h3 class="block-title">Afrekenen</h3>
          </div>
            <div class="bg-light rounded d-flex flex-column">
                <div class="p-2 d-flex">
                    <div class="col-8">Geretourneerde producten prijs: </div>
                    <div class="ml-auto">+ {{ Math.round((totalRefundPrice) * 100) / 100 }}</div>
                </div>
                <div class="p-2 d-flex">
                    <div class="col-8">Handmatig (extra) retourbedrag</div>
                    <div v-if="Math.sign(manualRefundPrice) === 1" class="ml-auto">+ {{manualRefundPrice}}</div>
                    <div v-else class="ml-auto">{{manualRefundPrice}}</div>
                </div>
                <div class="p-2 d-flex">
                    <div class="col-8">Verzendkosten</div>
                    <div v-if="incrementOrderShimentCosts" class="ml-auto">+ {{orderShippingCost}}</div>
                    <div v-else class="ml-auto">- {{orderShippingCost}}</div>
                </div>
                <div v-if="includeRefundShipmentCosts && calculateRefundShipmentCosts" class="p-2 d-flex">
                    <div class="col-8">Retour Kosten</div>
                    <div class="ml-auto">- {{refundShippingCost}}</div>
                </div>
                <div class="border-top px-4 mx-3"></div>
                <div class="p-2 d-flex pt-3">
                    <div class="col-8"><b>Totaal</b></div>
                    <div class="ml-auto"><b class="green">€ {{ calculateTotalRefundCost }}</b></div>
                </div>
            </div>
          </div>
      </div>
      <div v-if="refund.status !== 'completed'" class="p-2 d-flex pt-3">
        <button class="btn btn-hero btn-alt-success" style="margin-right: 0px" @click="updateRefundPrice">Retour verwerken</button>
      </div>
      <div v-if="refund.status === 'completed' && !isFromMarketPlace" class="p-2 d-flex pt-3">
        <div class="border-top px-4 mx-3"></div>
          <div class="ml-auto"><b class="green">Totaal terug geboekt bedrag: € {{ refund.refund_cost }}</b></div>
      </div>
    </span>
</template>

<script>
import RefundStatusBadge from './RefundStatusBadge.vue'
import OrderAddress from '../orders/OrderAddress.vue'
import OrderTimeline from '../orders/OrderTimeline.vue'
import ExcludeToggle from '../common/ExcludeToggle.vue'

export default {
  components: {
    RefundStatusBadge,
    OrderAddress,
    OrderTimeline,
    ExcludeToggle
  },
  props: {
    orderId: Number,
    refundId: Number,
    includeRefundShipmentCosts: Boolean
  },
  data () {
    return {
      order: null,
      refund: null,
      lines: {},
      shipment: {
        package_type: 1,
        insurance: false,
        large_format: false
      },
      totalRefundPrice: 0,
      manualRefundPrice: 0,
      orderShippingCost: null,
      calculateRefundShipmentCosts: true,
      includeOrderShipmentCosts: false,
      incrementOrderShimentCosts: false,
      orderStatus: false,
      sendRefundConformationMail: true
    }
  },
  computed: {
    calculateTotalRefundCost () {
      var total = 0

      total += Math.round((this.totalRefundPrice) * 100) / 100

      this.validateShipmentCosts()
      if (this.incrementOrderShimentCosts) {
        total += Math.round((this.orderShippingCost) * 100) / 100
      } else {
        total -= Math.round((this.orderShippingCost) * 100) / 100
      }

      if (this.calculateRefundShipmentCosts) {
        total -= this.refundShippingCost
      }

      this.validateManualRefundPrice(total)
      total += Math.round((this.manualRefundPrice) * 100) / 100

      return Math.round((total) * 100) / 100
    },
    pickedAt () {
      if (this.order.status === 'picked') {
        return this.order.updated_at
      }

      if (this.order.status === 'completed') {
        return this.completedAt
      }

      return null
    },
    orderLines () {
      if (this.order.number.substring(0, 3) === 'BOL') {
        return this.order.lines.filter(line => line.product_sku === this.refund.sales_channel_product_sku)
      } else {
        return this.order.lines.filter(line => line.product != null)
      }
    },
    refundShippingCost () {
      if (this.includeRefundShipmentCosts) {
        if (this.order.return_shipment !== null) {
          if (this.order.return_shipment.provider === 'homerr') {
            return 3.95
          }
          if (this.order.return_shipment.provider === 'dpd') {
            return 5.95
          }
        } else {
          return 0.00
        }
      } else {
        return 0.00
      }
    },
    completedAt () {
      if (this.order.status === 'completed') {
        return this.order.shipment ? this.order.shipment.created_at : this.order.updated_at
      }

      return null
    },
    isFromMarketPlace () {
      var marketplacesAbbreviated = [
        'BOL',
        'AMZ',
        'FON',
        'VTW'
      ]
      if (marketplacesAbbreviated.includes(this.order.number.substring(0, 3))) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    loadData () {
      const params = {
        include: 'lines,lines.product,shipment,returnShipment,refund'
      }
      this.$api.getOrder(this.orderId, params)
        .then((result) => {
          this.order = result.data.data
          this.lines = this.order.lines
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning')
        })

      this.$api.getRefund(this.refundId, [])
        .then((result) => {
          this.refund = result.data.data
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze retour konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    },
    setShippingCosts () {
      if (this.order.billing_country === 'NL') {
        this.orderShippingCost = 5.50
      } else {
        this.orderShippingCost = 5.95
      }
    },
    amountRefundedValue (value) {
      if (!this.refund.refund_products) {
        return 0
      }
      return this.refund.refund_products.find(x => x.product_id === value) ? this.refund.refund_products.find(x => x.product_id === value).amount_refunded : 0
    },
    stockIncreaseValue (value) {
      if (!this.refund.refund_products) {
        return 0
      }
      return this.refund.refund_products.find(x => x.product_id === value) ? this.refund.refund_products.find(x => x.product_id === value).new_quantity : 0
    },
    discountValue (value) {
      if (!this.refund.refund_products) {
        return 0
      }
      return this.refund.refund_products.find(x => x.product_id === value) ? this.refund.refund_products.find(x => x.product_id === value).discount : 0
    },
    getRefundedProducts () {
      var data = []
      var count = 0
      for (var item in this.$refs.quantityInput) {
        var line = this.lines.filter(x => x.id === parseInt(this.$refs.quantityInput[item].id))[0]
        var amountReturned = this.$refs.quantityInput[item].value

        if (amountReturned > 0 && !this.isFromMarketPlace) {
          data[count] = {
            'product_id': line.product.id,
            'new_quantity': amountReturned,
            'amount_refunded': this.$refs.input[item].value,
            'discount': this.$refs.priceInput[item].value
          }
        }
        count++
      }
      return data
    },
    validateShipmentCosts () {
      if (!this.includeOrderShipmentCosts) {
        this.orderShippingCost = 0
      } else {
        this.setShippingCosts()
      }
    },
    validateManualRefundPrice (total) {
      if ((total + this.manualRefundPrice) > this.order.total) {
        this.manualRefundPrice = 0
      } else if ((total + this.manualRefundPrice) < 0) {
        this.manualRefundPrice = 0
      }
    },
    updateOrderStatus () {
      if (this.orderStatus) {
        const data = {
          status: 'completed'
        }

        this.saving = true
        this.$http.patch(`/orders/${this.order.id}`, data)
        .then((response) => {
          this.saving = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }
        })
        .catch(() => {
          this.saving = false
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.`, 'error')
        })
      }
    },
    updateRefundPrice () {
      if (this.calculateTotalRefundCost > this.order.total) {
        this.$swal('Oeps! 😳', `Het bedrag dat geretourneerd moet worden mag niet groter zijn dan de totale bedrag van de bestelling`, 'error')
        return
      }
      const data = {
        refund_cost: this.calculateTotalRefundCost,
        status: 'completed',
        sendRefundConformationMail: this.sendRefundConformationMail,
        returned_products: this.getRefundedProducts()
      }
      this.saving = true
      this.$http.post(`/refunds/complete/${this.refund.id}`, data)
        .then((response) => {
          this.saving = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }
          this.updateOrderStatus()
          this.$swal('Retour betaling is geslaagd 😎', 'Dat scheelt weer.', 'warning')
        })
        .catch(() => {
          this.saving = false
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het verwerken van de retour. Probeer het opnieuw.`, 'error')
        })
    },
    calculateRefundPrice () {
      this.totalRefundPrice = 0
      for (var priceItem in this.$refs.priceInput) {
        if (isNaN(parseFloat(this.$refs.priceInput[priceItem].value)) === false) {
          var amount = this.$refs.input.filter(x => x.id === this.$refs.priceInput[priceItem].id)[0]
          var lineId = parseInt(this.$refs.priceInput[priceItem].id)
          var line = this.lines.filter(x => x.id === lineId)[0]
          var discount = parseFloat(this.$refs.priceInput[priceItem].value) / 100
          if (discount === 0) {
            discount = 1
          }
          var value = 0
          if (parseInt(amount.value) !== 0) {
            value = discount * (line.product_price * amount.value)
          } else {
            value = discount * (line.product_price * line.quantity)
          }
          this.totalRefundPrice += value
        }
      }
    },
    updateProductPrice (line) {
      for (var priceItem in this.$refs.priceInput) {
        if (parseInt(this.$refs.priceInput[priceItem].id) === line.id) {
          var value = parseFloat(this.$refs.priceInput[priceItem].value)
          if (value > 100) {
            this.$swal('Oeps! 😳', `Korting's percentage is te groot`, 'error')
          } else if (value < 0) {
            this.$swal('Oeps! 😳', `Korting's percentage is te klein`, 'error')
          } else {
            this.calculateRefundPrice()
          }
        }
      }
    },
    updateShippingCost () {
      var amount = parseInt(this.$refs.shippingInput.value)
      if (amount === 1) {
        this.orderShippingCost = this.order.shipping_cost
      } else {
        this.orderShippingCost = 0
      }
    },
    updateAmountOfProductRefunded (line) {
      for (var item in this.$refs.input) {
        if (parseInt(this.$refs.input[item].id) === line.id) {
          var amount = parseInt(this.$refs.input[item].value)
          for (var priceItem in this.$refs.priceInput) {
            if (parseInt(this.$refs.priceInput[priceItem].id) === line.id) {
              this.$refs.priceInput[priceItem].value = 0
              if (amount <= 0) {
                this.$refs.priceInput[priceItem].value = NaN
              } else {
                this.$refs.priceInput[priceItem].value = 0
              }
              if (amount > line.quantity) {
                this.$swal('Oeps! 😳', `Geleverde aantal is te groot`, 'error')
              } else if (amount < 0) {
                this.$swal('Oeps! 😳', `Geleverde aantal is te klein`, 'error')
              } else {
                this.calculateRefundPrice()
              }
            }
          }
          for (var quantityItem in this.$refs.quantityInput) {
            if (parseInt(this.$refs.quantityInput[quantityItem].id) === line.id) {
              this.$refs.quantityInput[quantityItem].value = amount
            }
          }
        }
      }
    }
  },
  created () {
    this.loadData()
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}
.operator-toggle::v-deep .btn {
  padding: 0.2rem 0.5rem;
}
</style>



// WEBPACK FOOTER //
// RefundForm.vue?8da3458e